"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseActivitySummary = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var il_progress_bar_1 = __importDefault(require("../il-progress-bar/il-progress-bar"));
var enums_1 = require("../../shared/enums");
var il_custom_icon_definitions_1 = require("../il-custom-icon/il-custom-icon-definitions");
var il_custom_icon_1 = require("../il-custom-icon/il-custom-icon");
var il_button_common_1 = require("../il-button/il-button.common");
var typeography_common_1 = require("../typeography/typeography.common");
var icon_1 = require("../icon/icon");
function NumberDescription(_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? 'primary.light' : _b, _c = _a.color, color = _c === void 0 ? 'primary.contrastText' : _c, amount = _a.amount, description = _a.description, iconSx = _a.iconSx;
    return (react_1.default.createElement(material_1.Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            gap: '1rem',
        } },
        react_1.default.createElement(il_custom_icon_1.ILCustomIcon, { type: enums_1.CustomIconTypeEnum.CUSTOM, size: enums_1.CustomIconSizeEnum.XXXLARGE, backgroundColor: backgroundColor, sx: iconSx, icon: function () { return (react_1.default.createElement(typeography_common_1.ILBody1, { sx: { fontSize: '1rem', fontWeight: 'bold', color: color } }, amount !== null && amount !== void 0 ? amount : 0)); } }),
        react_1.default.createElement(typeography_common_1.ILBody1, { sx: { fontSize: '1rem', fontWeight: '600' } }, description)));
}
function CourseActivitySummary(_a) {
    var _b;
    var className = _a.className, sx = _a.sx, status = _a.status, delayed = _a.delayed, _c = _a.progressPercent, progressPercent = _c === void 0 ? 0 : _c, _d = _a.delayPercent, delayPercent = _d === void 0 ? 0 : _d, showProgress = _a.showProgress, overrideHideIndicator = _a.overrideHideIndicator, letterGrade = _a.letterGrade, subjectIcon = _a.subjectIcon, iconColor = _a.iconColor, customIcon = _a.customIcon, title = _a.title, viewCourseLink = _a.viewCourseLink, viewCourseAction = _a.viewCourseAction, activitiesCompleted = _a.activitiesCompleted, activitiesOverdue = _a.activitiesOverdue, activitiesTotal = _a.activitiesTotal, onClose = _a.onClose;
    var theme = (0, material_1.useTheme)();
    var backgroundColor = iconColor || ((_b = il_custom_icon_definitions_1.IlCustomIcons[subjectIcon || 'CUSTOM']) === null || _b === void 0 ? void 0 : _b.backgroundColor);
    var totalPercent = progressPercent + delayPercent;
    var hideGuide = !(totalPercent > 0 && totalPercent < 100);
    var showViewCourse = viewCourseLink || viewCourseAction;
    return (react_1.default.createElement(material_1.Box, { className: 'il-couse-activity-summary ' + className, sx: __assign({ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: '0.9375rem', mb: '1.5rem' }, sx) },
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'row',
                px: '1rem',
                py: '0.5rem',
                mb: '1.125rem',
                justifyContent: 'space-between',
                alignItems: 'center',
                backgroundColor: backgroundColor,
            } },
            react_1.default.createElement(typeography_common_1.ILH3, { sx: { lineHeight: 1.21, fontSize: '2.8125rem', color: 'primary.contrastText' } }, letterGrade),
            onClose && (react_1.default.createElement(material_1.IconButton, { onClick: onClose, "data-testid": "close-icon" },
                react_1.default.createElement(icon_1.Icon, { icon: enums_1.IconEnum.X_MARK, size: enums_1.IconSizeEnum.XXSMALL, sx: {
                        color: 'primary.contrastText',
                    } })))),
        react_1.default.createElement(material_1.Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.9375rem',
                px: '1.5rem',
            } },
            react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    gap: '0.875rem',
                } },
                subjectIcon && (react_1.default.createElement(il_custom_icon_1.ILCustomIcon, { size: enums_1.CustomIconSizeEnum.XXXLARGE, type: subjectIcon, backgroundColor: backgroundColor, icon: customIcon })),
                react_1.default.createElement(typeography_common_1.ILH4, { sx: { fontWeight: 'bold', lineHeight: 1.21, fontSize: '1.5rem' } }, title)),
            (status || showProgress) && (react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '0.5rem',
                    width: '100%',
                } },
                status && (react_1.default.createElement(material_1.Chip, { label: status, size: "small", sx: __assign({ fontWeight: 600, fontSize: '0.875rem' }, (delayed && {
                        backgroundColor: (0, material_1.alpha)(theme.palette.error.main, 0.3),
                        color: theme.palette.error.main,
                    })) })),
                showProgress && (react_1.default.createElement(il_progress_bar_1.default, { progressPercent: progressPercent, delayPercent: delayPercent, hideGuide: overrideHideIndicator !== null && overrideHideIndicator !== void 0 ? overrideHideIndicator : hideGuide, height: "0.75rem", sx: {
                        width: '100%',
                    } })))),
            react_1.default.createElement(material_1.Divider, { sx: { my: '0.625rem', mx: '-1.5rem' } }),
            react_1.default.createElement(NumberDescription, { amount: activitiesCompleted, description: "Activities Completed" }),
            react_1.default.createElement(NumberDescription, { amount: activitiesOverdue, description: "Overdue Activities", backgroundColor: "error.main", iconSx: {
                    opacity: 0.6,
                } }),
            react_1.default.createElement(NumberDescription, { amount: activitiesTotal, description: "Total Activities", color: "text.primary", backgroundColor: "action.disabledBackground" }),
            showViewCourse && react_1.default.createElement(material_1.Divider, { sx: { my: '0.625rem', mx: '-1.5rem' } }),
            showViewCourse && (react_1.default.createElement(material_1.Box, { sx: {
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                } },
                react_1.default.createElement(material_1.Button, __assign({}, il_button_common_1.ContainedButtonArgs, { href: viewCourseLink, onClick: viewCourseAction }), "View Course"))))));
}
exports.CourseActivitySummary = CourseActivitySummary;
